var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefurbished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 41,
    viewBox: "0 0 50 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.21997 18.3398V39.5H37.01V35.96",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1099 3.51953C24.1999 2.67953 23.2899 1.84 22.3799 1C15.7399 6.78 9.08995 12.5598 2.44995 18.3398H13.5599",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5399 31.8804L42.9699 27.31C46.6099 21.74 45.9899 14.2 41.0999 9.31004C35.4899 3.70004 26.4099 3.70004 20.7999 9.31004C15.1899 14.92 15.1899 23.9998 20.7999 29.6098C25.6899 34.4998 33.2299 35.12 38.7999 31.48L43.3699 36.0503C44.5199 37.2003 46.3899 37.2003 47.5499 36.0503C48.6999 34.9003 48.6999 33.0306 47.5499 31.8706L47.5399 31.8804Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.716 9.45732L23.9716 18.2017L26.8864 21.1165L35.6308 12.3721L32.716 9.45732Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4288 19.6593L24.4574 20.6307",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7158 18.2018L37.8167 13.1009C38.2175 12.7001 38.2175 12.0443 37.8167 11.6435L36.3593 10.1861C35.9585 9.78532 35.3027 9.78532 34.9019 10.1861L34.1732 10.9148",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7161 18.2018L34.1732 19.6589",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7678 20.0647L34.5767 19.2559C35.0236 18.8089 35.7475 18.8089 36.1944 19.2559L39.9181 22.9795C40.365 23.4265 40.365 24.1503 39.9181 24.5972L39.1092 25.4061C38.6623 25.8531 37.9384 25.853 37.4915 25.4061L33.7678 21.6824C33.3209 21.2355 33.3209 20.5117 33.7678 20.0647Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5399 30.1494C39.9899 30.6494 39.4099 31.0902 38.7999 31.4902",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0699 29.1602H30.14V32.2295",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22 25.0898H26.07V29.1602",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 25.0898V21.0195L17.95 20.9795",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefurbished);
export default __webpack_public_path__ + "static/media/refurbished.e3dc10aa1033fa0f022c1e73554a7b8f.svg";
export { ForwardRef as ReactComponent };